/* PBF Over Frank roadmap — zelfstandige reveal: de stengel groeit, de nodes 'poppen'
   en de kaarten faden in. Bewust ZICHTBAAR-by-default: als JS faalt of niet laadt,
   blijft alle content gewoon zichtbaar (geen afhankelijkheid van pbf-stagger.js). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = typeof IntersectionObserver !== 'undefined';

  function run() {
    var axes = document.querySelectorAll('[data-pbf-roadmap]');
    if (!axes.length) return;

    // Geen animatie gewenst/mogelijk → alles meteen in eindstand (al zichtbaar).
    if (reduce || !hasIO) {
      axes.forEach(function (el) { el.classList.add('is-grown'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-grown');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.15 }
    );

    axes.forEach(function (el) {
      el.classList.add('is-ready');   // zet de animatie-startstand (verbergt tot in-view)
      observer.observe(el);
    });
  }

  // Direct draaien: het script staat ná de sectie-markup, dus de axis bestaat al.
  run();
})();
